import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_TABLE: GlameraIconDefinition = {
  name: 'table',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-table-column" d="M12 3v18"></path>
    <rect class="glm-table-body" width="18" height="18" x="3" y="3" rx="2"></rect>
    <path class="glm-table-row glm-table-row-top" d="M3 9h18"></path>
    <path class="glm-table-row glm-table-row-bottom" d="M3 15h18"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-table-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './table.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TableIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_TABLE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
